const Footer = () => {
    return (
        <footer className="bdT ta-c p-30 lh-0 fsz-sm c-grey-600">
            <span>Copyright © 2023</span>
        </footer>
    )
}

export default Footer